export default __webpack_public_path__ + "static/media/iamsmart-tap.877082cd.png";